import styled from "@emotion/styled";

export const QuestionWrapper = styled.div``;

export default QuestionWrapper;
